"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPermissionData = void 0;
const EnumObject_1 = require("./EnumObject");
const enumValues = {
    D_READ: "R",
    D_WRITE: "W",
    D_READ_ORG: "RO",
    D_WRITE_ORG: "WO",
    D_READ_ALL: "RA",
    D_WRITE_ALL: "WA",
};
class EPermissionData extends EnumObject_1.EnumObject {
    constructor(value) {
        super(value);
    }
    static create(p) {
        return new EPermissionData(p);
    }
}
exports.EPermissionData = EPermissionData;
EPermissionData.V = enumValues;
//# sourceMappingURL=EPermissioData.js.map